
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/ShopWithHappy",
      function () {
        return require("private-next-pages/article/ShopWithHappy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/ShopWithHappy"])
      });
    }
  